/**
 * traffic right icon
 * zxw
 * 2024-09-26
 */


import Icon from '@ant-design/icons';
import { ReactComponent as TRAFFICRIGHT } from '../../images/traffic-right-icon.svg';
 
const TRIcon = (props) => {
  return <Icon component={TRAFFICRIGHT} {...props} />;
};
 
export default TRIcon;